import type { Route, RouteConfig } from 'vue-router'
import { allRoles, isAuthorized, lazyLoadView } from '@/router/routing'

export const legacyRoutes: RouteConfig[] = [
  {
    path: 'ui-scale',
    name: 'ui-scale',
    component: () => lazyLoadView(import('@/ui-kit/views/legacy/UiKitScaleView.vue')),
    meta: {
      title: 'Scales',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-scale',
    },
  },
  {
    path: 'ui-slider',
    name: 'ui-slider',
    component: () => lazyLoadView(import('@/ui-kit/views/legacy/UiKitSliderView.vue')),
    meta: {
      title: 'Slider',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-slider',
    },
  },
  {
    path: 'ui-p-check',
    name: 'ui-p-check',
    component: () => lazyLoadView(import('@/ui-kit/views/legacy/UiKitPCheckView.vue')),
    meta: {
      title: 'PCheck',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-p-check',
    },
  },
  {
    path: 'ui-form-field',
    name: 'ui-form-field',
    component: () => lazyLoadView(import('@/ui-kit/views/legacy/UiKitFormFieldView.vue')),
    meta: {
      title: 'FormField',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-form-field',
    },
  },
  {
    path: 'ui-form-field-select',
    name: 'ui-form-field-select',
    component: () => lazyLoadView(import('@/ui-kit/views/legacy/UiKitFormFieldSelectView.vue')),
    meta: {
      title: 'FormFieldSelect',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-form-field-select',
    },
  },
  {
    path: 'ui-form-field-checkbox',
    name: 'ui-form-field-checkbox',
    component: () => lazyLoadView(import('@/ui-kit/views/legacy/UiKitFormFieldCheckboxView.vue')),
    meta: {
      title: 'FormFieldCheckbox',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-form-field-checkbox',
    },
  },
  {
    path: 'ui-form-field-date',
    name: 'ui-form-field-date',
    component: () => lazyLoadView(import('@/ui-kit/views/legacy/UiKitFormFieldDateView.vue')),
    meta: {
      title: 'FormFieldDate',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-form-field-date',
    },
  },
  {
    path: 'ui-form-field-toggle',
    name: 'ui-form-field-toggle',
    component: () => lazyLoadView(import('@/ui-kit/views/legacy/UiKitFormFieldToggleView.vue')),
    meta: {
      title: 'FormFieldToggle',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-form-field-toggle',
    },
  },
  {
    path: 'ui-app-button',
    name: 'ui-app-button',
    component: () => lazyLoadView(import('@/ui-kit/views/legacy/UiKitAppButtonView.vue')),
    meta: {
      title: 'AppButton',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-app-button',
    },
  },
  {
    path: 'ui-confirm',
    name: 'ui-confirm',
    component: () => lazyLoadView(import('@/ui-kit/views/legacy/UiKitConfirmView.vue')),
    meta: {
      title: 'Confirm',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-confirm',
    },
  },
]
